const VERSION: string = '0.1.7-prod.11'
export default VERSION;
